import { FormProvider as RCFormProvider } from "rc-field-form";
import { FormProviderProps as RCFormProviderProps } from "rc-field-form/es/FormContext";
import { useTranslation } from "react-i18next";

interface FormProviderProps extends Omit<RCFormProviderProps, "validateMessages"> {}

export const FormProvider: React.FC<FormProviderProps> = ({ ...props }) => {
  const { t } = useTranslation("common");

  const typeTemplate = t("form_validation_messages.types");

  const ValidateMessages = {
    default: t("form_validation_messages.default"),
    required: t("form_validation_messages.required"),
    enum: t("form_validation_messages.enum"),
    whitespace: t("form_validation_messages.whitespace"),
    date: {
      format: t("form_validation_messages.date.format"),
      parse: t("form_validation_messages.date.parse"),
      invalid: t("form_validation_messages.date.invalid"),
    },
    types: {
      string: typeTemplate,
      method: typeTemplate,
      array: typeTemplate,
      object: typeTemplate,
      number: typeTemplate,
      date: typeTemplate,
      boolean: typeTemplate,
      integer: typeTemplate,
      float: typeTemplate,
      regexp: typeTemplate,
      email: typeTemplate,
      url: typeTemplate,
      hex: typeTemplate,
    },
    string: {
      len: t("form_validation_messages.string.len"),
      min: t("form_validation_messages.string.min"),
      max: t("form_validation_messages.string.max"),
      range: t("form_validation_messages.string.range"),
    },
    number: {
      len: t("form_validation_messages.number.len"),
      min: t("form_validation_messages.number.min"),
      max: t("form_validation_messages.number.max"),
      range: t("form_validation_messages.number.range"),
    },
    array: {
      len: t("form_validation_messages.array.len"),
      min: t("form_validation_messages.array.min"),
      max: t("form_validation_messages.array.max"),
      range: t("form_validation_messages.array.range"),
    },
    pattern: {
      mismatch: t("form_validation_messages.pattern.mismatch"),
    },
  };

  return <RCFormProvider validateMessages={ValidateMessages} {...props} />;
};
